import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobs } from "../../slice/jobSlice";
import { Link } from "react-router-dom";
import { FaBriefcase } from "react-icons/fa";

// const categoryOptions = ["All", "Development", "Design", "Finance", "Marketing"];


const Jobs = () => {
  const dispatch = useDispatch();
  const { jobs = [], loading, error } = useSelector((state) => state.job);

  const [visibleCount, setVisibleCount] = useState(10);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [animatedJobIds, setAnimatedJobIds] = useState([]);

  const newJobsRef = useRef(null);

  useEffect(() => {
    if (!jobs || jobs.length === 0) {
      dispatch(fetchJobs());
    }
  }, [dispatch, jobs]);

  const filteredJobs =
    selectedCategory === "All"
      ? jobs
      : jobs.filter((job) => job.category === selectedCategory);

  const jobsToShow = filteredJobs.slice(0, visibleCount);
  const showViewButton = filteredJobs.length > 10;

  const handleCategoryChange = (cat) => {
    setSelectedCategory(cat);
    setVisibleCount(10);
    setAnimatedJobIds([]);
    if (newJobsRef.current) {
      newJobsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleToggleView = () => {
    const previousCount = visibleCount;
    const nextCount =
      visibleCount >= filteredJobs.length ? 10 : visibleCount + 10;

    const newAnimatedIds = filteredJobs
      .slice(previousCount, nextCount)
      .map((job) => job._id || job.id);

    setVisibleCount(nextCount);
    setAnimatedJobIds((prev) => [...prev, ...newAnimatedIds]);

    setTimeout(() => {
      if (newJobsRef.current) {
        newJobsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
  };

  return (
    <div className=" bg-white px-4 sm:px-6 py-12">


      <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-10 max-w-7xl mx-auto">
        <div className="flex flex-wrap gap-3">
          {/* {categoryOptions.map((cat) => (
            <button
              key={cat}
              onClick={() => handleCategoryChange(cat)}
              className={`px-4 py-1 rounded-lg border transition ${
                selectedCategory === cat
                  ? "bg-[#2B3DA8] text-white"
                  : "bg-white text-[#2B3DA8] border-[#2B3DA8]"
              } hover:bg-[#2B3DA8] hover:text-white`}
            >
              {cat}
            </button>
          ))} */}
          <h1 className="text-3xl sm:text-4xl font-bold text-[#fc3c04] text-center mb-8">
            Available <span className="text-[#345bf3]">Jobs</span> 
          </h1>

        </div>

        {showViewButton && (
          <button
            onClick={handleToggleView}
            className="text-white  bg-[#686104] px-4 py-2 rounded-full hover:bg-[#fc3c04] transition whitespace-nowrap"
          >
            {visibleCount >= filteredJobs.length ? "View Less" : "View More"}
          </button>
        )}
      </div>

      <div className="space-y-4 max-w-7xl mx-auto">
        {loading ? (
          <p className="text-center text-gray-500">Loading...</p>
        ) : error ? (
          <p className="text-center text-red-500">Error: {error}</p>
        ) : jobsToShow.length > 0 ? (
          jobsToShow.map((job, index) => {
            const jobId = job._id || job.id;
            if (!jobId) return null;

            const isAnimated = animatedJobIds.includes(jobId);
            const fadeInClass = isAnimated ? "animate-fade-in" : "";

            return (
              <div
                key={jobId}
                ref={isAnimated && index === visibleCount - 10 ? newJobsRef : null}
                className={`flex flex-col sm:flex-row justify-between items-start sm:items-center border border-gray-200 rounded-lg hover:shadow-md group bg-white ${fadeInClass}`}
              >
                <Link
                  to={`/job/${jobId}`}
                  className="w-full p-4 grid grid-cols-1 sm:grid-cols-12 gap-y-2 sm:gap-4 group-hover:bg-gray-50"
                >
                  <div className="sm:col-span-4 text-base sm:text-lg font-semibold text-[#345bf3]">
                    <div className="flex items-center gap-2">
                    <FaBriefcase size={18} className="text-[#fc3c04] min-w-[18px] mt-[1px]" />
                      {job.jobTitle}
                    </div>
                  </div>
                  <div className="sm:col-span-2 text-sm text-gray-700">{job.companyName}</div>
                  <div className="sm:col-span-2 text-sm text-gray-700">{job.location}</div>
                  <div className="sm:col-span-2 text-sm  text-green-500">{job.jobType}</div>
                  <div className="sm:col-span-2 text-sm text-gray-700">{job.salary}</div>
                </Link>
                <div className="flex justify-start px-4 pb-4">
                  <Link to={`/job/${jobId}`}>
                    <span className="text-white bg-[#345bf3] text-sm px-4 py-2 rounded-md hover:bg-[#fc3c04] transition whitespace-nowrap">
                      Read More
                    </span>
                  </Link>
                </div>
              </div>
            );
          })
        ) : (
          <p className="text-center text-gray-500">No jobs found in this category.</p>
        )}
      </div>
    </div>
  );
};

export default Jobs;
